// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1QDH3","comment":"styles_comment__2jH_6"};